import { jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import PropTypes from "prop-types";
import { MenuItem } from "@reach/menu-button";
import { dropdownMenuContext } from "./dropdown-menu-context.es.js";
import { DropdownMenuItemImpl } from "./dropdown-menu-item.styles.es.js";
import { useHandler } from "../../hooks/use-handler.es.js";
const propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  preventDefault: PropTypes.bool,
  variant: PropTypes.oneOf(["accent", "danger"])
};
const defaultProps = {
  as: MenuItem,
  disabled: false,
  onSelect: void 0,
  preventDefault: true,
  variant: void 0
};
const DropdownMenuItem = forwardRef(
  ({ as, children, disabled, onSelect, preventDefault, variant, ...restProps }, ref) => {
    const { appearance, magnitude } = useContext(dropdownMenuContext);
    const handleClick = useHandler((event) => {
      if (preventDefault) {
        event.preventDefault();
      }
    });
    const handleSelect = useHandler(onSelect);
    if (disabled) {
      return /* @__PURE__ */ jsx(
        DropdownMenuItemImpl,
        {
          $appearance: appearance,
          $magnitude: magnitude,
          disabled,
          onSelect: handleSelect,
          variant,
          ref,
          ...restProps,
          children
        }
      );
    }
    return /* @__PURE__ */ jsx(
      DropdownMenuItemImpl,
      {
        as,
        $appearance: appearance,
        $magnitude: magnitude,
        onClick: handleClick,
        onSelect: handleSelect,
        variant,
        ref,
        ...restProps,
        children
      }
    );
  }
);
DropdownMenuItem.propTypes = propTypes;
DropdownMenuItem.defaultProps = defaultProps;
export {
  DropdownMenuItem
};
